const getApiDomain = () => {
	const domain = PRODUCTION ? "https://wolverine.talent.performyard.com" : "http://localhost:4000";
	return domain;
};

module.exports = {
	getApiDomain,
};
